import {useEffect, useState} from 'react';

import Grid from '@mui/material/Grid';

import PageContainer from '../../components/layout/PageContainer';
import SecretsByCategory from '../../components/secrets/SecretsByCategory/SecretsByCategory';
import Spinner from '../../components/spinner/Spinner';
import PageTitle from '../../components/typography/PageTitle';
import useProjects from '../../hooks/providers/useProjects';
import useUserSecrets from '../../hooks/providers/useUserSecrets';

const UserSecrets = () => {
  const {connectors} = useProjects();
  const {secrets, getUserSecrets} = useUserSecrets();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (secrets) return;

    (async () => {
      setLoading(true);
      await getUserSecrets();
      setLoading(false);
    })();
  }, [secrets]);

  return (
    <PageContainer>
      <PageTitle>Gérer mes secrets</PageTitle>

      {loading ? (
        <Grid container flex={1}>
          <Spinner isLoading text="Chargement des secrets" />
        </Grid>
      ) : null}

      {secrets && <SecretsByCategory secrets={secrets} connectors={connectors} />}
    </PageContainer>
  );
};

UserSecrets.propTypes = {};

export default UserSecrets;
